import { REDIRECT_TYPE, REDIRECT_TYPE_CODES } from 'enums/seo-shared'
import { ROUTE } from 'enums/routes'
import { addEndingSlash, parseUrl } from '@/utils/helpers'

export default async function(ctx) {
  const { route, redirect } = ctx

  const fullPath = route.fullPath || ROUTE.HOMEPAGE

  const currentPath = (route.path || '').toLowerCase()

  if (currentPath === ROUTE.HOMEPAGE) {
    redirect(
      REDIRECT_TYPE_CODES[REDIRECT_TYPE.MOVED_TEMPORARILY],
      `${process.env.FM_DOMAIN_URL}/intelligence/`
    )
  }

  const { address, query, hash } = parseUrl(fullPath)

  const processedFullPath = `${addEndingSlash(address)}${query}${hash}`

  if (processedFullPath !== fullPath) {
    redirect(
      REDIRECT_TYPE_CODES[REDIRECT_TYPE.MOVED_PERMANENTLY],
      processedFullPath
    )

    return
  }

  redirect()
}
